// extracted by mini-css-extract-plugin
export default {"icon":"root_chat-list-button-module__icon___jgee3","text":"root_chat-list-button-module__text___VqvwD"};